import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { IFilePreview } from '../../../shared/models/file-preview';

@Component({
    selector: 'app-file-preview',
    templateUrl: './file-preview.html',
    standalone: false
})

export class FilePreviewComponent implements OnInit {
  iframeSrc!: SafeResourceUrl;
  iframeSrcDoc!: SafeHtml;
  private objectUrl!: string;

  constructor(
    public dialogRef: MatDialogRef<FilePreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IFilePreview,
    private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    let byteArray = new Uint8Array(atob(this.data.fileContent).split('').map(c => c.charCodeAt(0)));

    let fileExtension = this.data.fileName.split('.').pop();
    if (fileExtension) {
      if (fileExtension.toLowerCase() === 'pdf') {
        let blob = new Blob([byteArray], { type: "application/pdf" });
        this.objectUrl = window.URL.createObjectURL(blob);

        this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.objectUrl);
      }
      else if (fileExtension.toLowerCase() === 'msg' && this.data.outlookMessage) {
        this.iframeSrcDoc = this.sanitizer.bypassSecurityTrustHtml(this.data.outlookMessage.htmlBody);
      }
    }
  }

  ngOnDestroy() {
    if (this.iframeSrc) {
      window.URL.revokeObjectURL(this.objectUrl);
    }
  }

  close() {
    this.dialogRef.close();
  }
}
